/* eslint-disable @typescript-eslint/no-explicit-any */
import classes from './CellProductionsStartMintWithoutRemoveActions.module.css';
import { Box, rem, Image } from '@mantine/core';
import { ActionIcon } from '@mantine/core';
import IconViewMore from '@assets/icons/view-more.svg';

export const CellProductionsStartMintWithoutRemoveActions =
	(props: {
		onViewMore?: (data: any) => void;
		row?: any;
	}) => {
		return (
			<Box
				style={{
					display: 'flex',
				}}
			>
				<ActionIcon
					data-testid="W4OtPXR1_Z5jdHi6B-menu"
					variant="transparent"
					className={classes.customSize}
					onClick={(event) => {
						event.stopPropagation();
						if (props && props.row) {
							props.onViewMore!(props.row);
						}
					}}
				>
					<Image
						style={{
							objectFit: 'contain',
							width: rem(22),
							height: rem(22),
						}}
						src={IconViewMore}
					/>
				</ActionIcon>
			</Box>
		);
	};
